export function getInitialPhotographerId(): number | null {
    let persistedPhotographer = getPersistedPhotographer();
    let persistedPhotographerId = persistedPhotographer ? persistedPhotographer.id : null;

    if (persistedPhotographerId) {
        return persistedPhotographerId;
    }

    return null;
}

const STORAGE_PHOTOGRAPHER = 'pd';

export function getPersistedPhotographer(): { id: number; name: string; avatarRef: string } | null {
    let rawSavedPhotographer = localStorage.getItem(STORAGE_PHOTOGRAPHER);

    try {
        let savedPhotographer = JSON.parse(rawSavedPhotographer);
        return savedPhotographer;
    } catch (error) {
        console.error('Error parsing photographer from storage!', error);
    }

    return null;
}

export function persistPhotographer(id: number, name: string, avatarRef: string) {
    localStorage.setItem(STORAGE_PHOTOGRAPHER, JSON.stringify({ id, name, avatarRef }));
}

export function clearPersistedPhotographer() {
    localStorage.removeItem(STORAGE_PHOTOGRAPHER);
}
